import Vue from 'vue'
import VueRouter from 'vue-router'
import children from './router'
Vue.use(VueRouter)
// 重复点击相同路由不报错
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error)
}

const routes = [

  { // 配置默认路由
    path: "/", // 路由地址
    redirect: "/manage" // 重定向
  },
  {
    path: '/manage/',
    name: 'manage',
    component: () => import('../views/home/index'),
    children: [
      ...children
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/index'),

  }


]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  let uid = to.query.uid ? to.query.uid : '';
  //to到哪儿 from从哪儿离开 next跳转 为空就是放行 
  if (to.path === '/login' || uid != '') {
    //如果跳转为登录，就放行 
    next();
  } else {
    //取出localStorage判断
    let token = localStorage.getItem('token');
    if (token == null || token === '') {
      console.log('请先登录')
      next({ name: 'login' });
    } else {
      next();
    }
  }
});
export { routes };

export default router;
